module.exports = "./img/desktop_logo.39174f5.png";